var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3147 17.0693C22.2882 14.3601 24.8797 12.4226 27.9235 12.4226C30.9743 12.4226 33.5707 14.369 34.539 17.088",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0763 37.2379H31.8429C29.2658 37.2379 27.1767 35.1483 27.1767 32.5707C27.1767 29.9932 29.2658 27.9036 31.8429 27.9036H44.0763",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4307 32.5708H35.2912",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5588 10.0544H7.24266C5.09944 10.0544 3.36206 11.7922 3.36206 13.9359",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4915 17.8579L41.5668 17.7682C42.9976 16.3509 42.9976 14.0531 41.5668 12.6358L30.9249 2.09423C29.4941 0.676922 27.1745 0.676922 25.7437 2.09423L10.005 17.6846",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.404 17.8173H7.24266C5.15072 17.8173 3.4455 16.1617 3.36506 14.0891H3.36206V43.0875C3.36206 45.2311 5.11641 46.9689 7.28044 46.9689H40.404C42.7424 46.9689 44.6379 45.0912 44.6379 42.7748V22.0114C44.6379 19.695 42.7423 17.8173 40.404 17.8173Z",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWallet);
export default __webpack_public_path__ + "static/media/ic-wallet.d6df1f6fcf9f3dda02bda9296bed26af.svg";
export { ForwardRef as ReactComponent };